<template>
	<div class="modal-footer text-left">
		<div class="row">
			<div class="col-sm-10">
				<span>CNAE</span>
				<drop-draw
					v-model="defAtividade"
					placeholder="Escolher"
					radio
					:asset="atividades"
					cod="code"
					title="text"
				/>
			</div>
			<div class="col-sm-2">
				<span>G R CLIENTE</span>
				<input
					class="form-control"
					disabled
					:value="dadosDaEmpresa.dados_tecnicos.grau_risco"
				/>
			</div>
		</div>
		<br />
		<div class="row">
			<div class="col-sm-2">
				<span>CIPA - GRUPO</span>
				<input
					type="text"
					disabled
					class="form-control"
					:value="dadosDaEmpresa.dados_tecnicos.cipa_grupo"
				/>
			</div>

			<div class="col-sm-2">
				<span>Enquadramento</span>
				<input
					disabled
					class="form-control"
					:value="dadosDaEmpresa.dados_tecnicos.enquadramento"
				/>
			</div>
			<div class="col-sm-2">
				<span>Total Func.</span>
				<input disabled class="form-control" :value="totalFunc" />
			</div>

			<div class="col-sm-2">
				<span>EFETIVOS</span>
				<input
					type="text"
					disabled
					class="form-control"
					:value="dadosDaEmpresa.dados_tecnicos.efetivo"
				/>
			</div>
			<div class="col-sm-2">
				<span>SUPLENTES</span>
				<input
					type="text"
					disabled
					class="form-control"
					:value="dadosDaEmpresa.dados_tecnicos.suplente"
				/>
			</div>
			<div class="col-sm-2">
				<span>C. MEMBROS</span>
				<input
					type="text"
					disabled
					class="form-control"
					:value="dadosDaEmpresa.dados_tecnicos.cipa_membros"
				/>
			</div>
		</div>
	</div>
</template>
<script>
	const DadosTecnicosInicial = {
		cipa_grupo: 'Não aplicavél',
		atividade_economica: 'Não aplicavél',
		grau_risco: 'Não aplicavél',
		enquadramento: 'Não aplicavél',
		efetivo: 'Não aplicavél',
		suplente: 'Não aplicavél',
		cipa_membros: 'Não aplicavél',
	};

	import { clone } from 'lodash';
	import dropDraw from 'dropdraw';

	export default {
		components: { dropDraw },
		props: ['dadosDaEmpresa', 'totalFunc'],
		inject: ['assets'],
		watch: {
			totalFunc: function (val) {
				this.selectCnae(this.dadosDaEmpresa.atividade_principal);
			},
		},
		computed: {
			atividades() {
				return this.dadosDaEmpresa.atividades.reduce((acc, item) => {
					acc.push({
						code: item.code,
						text: `${item.code} - ${item.text}`,
					});
					return acc;
				}, []);
			},
			defAtividade: {
				set(val) {
					this.$emit('setAtividadePrincipal', val);
					if (val.length == 10) {
						this.selectCnae(val);
					}
				},
				get() {
					return this.dadosDaEmpresa.atividade_principal;
				},
			},
		},
		methods: {
			// getCnae(){
			//   console.log('get', this.dadosDaEmpresa.atividade_principal)
			//   this.dadosDaEmpresa.atividade_principal
			// },
			// setCnae(val){
			//   this.$emit("setAtividadePrincipal", val)
			//   if(val.length == 10){
			//     this.selectCnae(val)
			//   }
			// },

			selectCnae(val) {
				if (val == '') return;
				const dadosTecnicos = this.update_cnea_cod(val);
				this.$emit('setDadosTecnicos', dadosTecnicos);
			},
			update_cnea_cod(t) {
				if (t == '00.00-0-00') return clone(DadosTecnicosInicial);
				const dados_tecnicos = clone(DadosTecnicosInicial);
				// Relacionamento cnae cipa
				let relCnaeCipa = this.assets.relacionamento_cnae_cipa.find(
					(item) => t.indexOf(item.cccp_cnae) != -1
				);
				(dados_tecnicos.cipa_grupo = relCnaeCipa.cccp_grupo),
					(dados_tecnicos.atividade_economica =
						relCnaeCipa.cccp_atividade_economica);

				// Grau de risco
				let before = 0;
				let gRisco = null;
				this.assets.grau_de_risco.forEach((item) => {
					if (
						t.indexOf(item.grr_cod) != -1 &&
						item.grr_cod.length > before
					) {
						before = item.grr_cod.length;
						gRisco = item;
					}
				});
				dados_tecnicos.grau_risco = parseInt(gRisco.grr_grau);

				// Enquadramento Cipa ...
				let enq = this.assets.enquadramento_cipa.filter(
					(item) => item.grupo == relCnaeCipa.cccp_grupo
				);
				let tEnq = this.tipo_enquadramento();
				dados_tecnicos.enquadramento = tEnq;

				let efetivo = 1;
				let suplente = 1;
				if (enq.length != 0) {
					efetivo = enq[0].membros ? 0 : 1;
					suplente = efetivo == 0 ? 1 : 0;

					efetivo =
						enq[efetivo][tEnq] == '' ? 1 : enq[efetivo][tEnq] * 2;
					suplente =
						enq[suplente][tEnq] == '' ? 1 : enq[suplente][tEnq] * 2;
				}

				dados_tecnicos.efetivo = efetivo;
				dados_tecnicos.suplente = suplente;
				dados_tecnicos.cipa_membros =
					parseInt(efetivo) + parseInt(suplente);

				return dados_tecnicos;
			},
			tipo_enquadramento() {
				let intervals = {
					i: [0, 19],
					ii: [20, 29],
					iii: [30, 50],
					iv: [51, 80],
					v: [81, 100],
					vi: [101, 120],
					vii: [121, 140],
					viii: [141, 300],
					ix: [301, 500],
					x: [501, 1e3],
					xi: [1e3, 2500],
					xii: [2501, 5e3],
					xiii: [5001, 1e4],
					xiv: [10001, 999999],
				};
				for (var type in intervals) {
					if (
						this.totalFunc >= intervals[type][0] &&
						this.totalFunc <= intervals[type][1]
					) {
						return type;
					}
				}
			},
		},
	};
</script>
<style scoped>
	.text-left {
		text-align: left;
	}
</style>



// WEBPACK FOOTER //
// src/components/sst/seguranca/components/dimencionamento/components/CalculoCNAEeSST/index.vue